@import 'styles/variables.scss';

.container {
  padding-top: $navbar-height;
}
